import { render, staticRenderFns } from "./unqualifiedDestructionReview.vue?vue&type=template&id=6670518e&scoped=true"
import script from "./unqualifiedDestructionReview.vue?vue&type=script&lang=js"
export * from "./unqualifiedDestructionReview.vue?vue&type=script&lang=js"
import style0 from "./unqualifiedDestructionReview.vue?vue&type=style&index=0&id=6670518e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6670518e",
  null
  
)

export default component.exports